export const REDUCER_AUTH = 'auth';
export const AUTH_API = 'authApi';
